import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { AlloyButton, Popup, RemanufacturedIcon } from 'cat-ecommerce-alloy';
import { GENUINE } from '@app/constants/productAssociation';

const ProductPrimaryAttributes = ({ productId }) => {
  const [t] = useTranslation();
  const brand = useSelector(s => s.products.byId?.[productId]?.manufacturer);
  const merchandisingAssociations = useSelector(
    s => s.products.byId?.[productId]?.merchandisingAssociations
  );
  const getAssociatedPartByType = type =>
    Array.isArray(merchandisingAssociations)
      ? merchandisingAssociations.find(
          ({ associationType }) => associationType === type
        )
      : undefined;
  const remanType = getAssociatedPartByType(GENUINE);
  const popupContent = (
    <div className="u-fs--12">
      <p>{t('CAT_REMAN_VAL_STMT')}</p>
      <p>{t('CAT_REMAN_VAL_STMT_1')}</p>
    </div>
  );
  const initiator = (
    <AlloyButton buttonType="link" className="p-0">
      <RemanufacturedIcon className="u-fill--DarkGray" />
      <span className="u-color--MediumBlue u-fs--14 p-0 ps-1">
        {t('CAT_R_REMAN')}
      </span>
    </AlloyButton>
  );
  const popperOptions = { placement: 'bottom' };
  const shortDescription = useSelector(
    s => s.products.byId?.[productId]?.shortDescription
  );
  return (
    <div className="pb-2">
      {shortDescription && (
        <p className="u-fs-lg--14 mb-16"> {shortDescription}</p>
      )}
      <p className="mb-0">{`${t('CPG_BRAND')}: ${brand}`}</p>
      {remanType && (
        <Popup
          contents={popupContent}
          initiator={initiator}
          popperOptions={popperOptions}
          className="w-50"
        />
      )}
    </div>
  );
};

ProductPrimaryAttributes.propTypes = {
  productId: PropTypes.string
};

export default ProductPrimaryAttributes;
